import { Paperclip, X } from "lucide-react";
import { Field, fieldClass, Group, labelClass } from "./BriefField";

const ACCEPT = ".pdf,.png,.jpg,.jpeg,.webp,.zip,.doc,.docx,.txt,.csv";

export const BriefScope = ({ form, set, file, fileInput, pickFile, clearFile }) => (
  <Group id="03" title="Scope & Context">
    <div className="grid gap-7 md:grid-cols-2">
      <Field label="Desired Launch Date" hint="optional" htmlFor="brief-launch-date">
        <input
          id="brief-launch-date"
          type="date"
          data-testid="brief-launch-date-input"
          className={fieldClass}
          value={form.launch_date}
          onChange={set("launch_date")}
        />
      </Field>
      <Field label="Approximate Budget" hint="optional" htmlFor="brief-budget">
        <input
          id="brief-budget"
          data-testid="brief-budget-input"
          className={fieldClass}
          value={form.budget}
          onChange={set("budget")}
          placeholder="Range or ballpark"
        />
      </Field>
    </div>

    <Field label="Reference Links" hint="optional" htmlFor="brief-references">
      <textarea
        id="brief-references"
        data-testid="brief-references-input"
        rows={3}
        maxLength={2000}
        className={`${fieldClass} resize-none`}
        value={form.references}
        onChange={set("references")}
        placeholder="Anything that helps us understand the direction"
      />
    </Field>

    <div>
      <span className={labelClass}>
        File Upload <span className="ml-2 text-[#F4F6FB]/25">optional · max 10MB</span>
      </span>
      <input
        ref={fileInput}
        id="brief-file"
        type="file"
        data-testid="brief-file-input"
        onChange={pickFile}
        className="sr-only"
        accept={ACCEPT}
      />
      <div className="flex flex-wrap items-center gap-4">
        <button
          type="button"
          data-testid="brief-file-button"
          onClick={() => fileInput.current?.click()}
          className="inline-flex items-center gap-3 rounded-full border border-white/10 bg-white/5 px-5 py-3 font-mono text-[10px] uppercase tracking-[0.22em] text-[#F4F6FB]/70 transition-colors duration-300 hover:border-[#06B6D4]/50 hover:text-[#F4F6FB]"
        >
          <Paperclip className="h-3.5 w-3.5" />
          Attach a file
        </button>
        {file && (
          <span
            data-testid="brief-file-name"
            className="inline-flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.2em] text-[#06B6D4]"
          >
            {file.name}
            <button
              type="button"
              data-testid="brief-file-remove"
              aria-label="Remove attached file"
              onClick={clearFile}
              className="text-[#F4F6FB]/40 transition-colors duration-300 hover:text-[#F4F6FB]"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </span>
        )}
      </div>
    </div>

    <Field label="Additional Notes" hint="optional" htmlFor="brief-notes">
      <textarea
        id="brief-notes"
        data-testid="brief-notes-input"
        rows={3}
        maxLength={2000}
        className={`${fieldClass} resize-none`}
        value={form.notes}
        onChange={set("notes")}
        placeholder="Anything else we should know"
      />
    </Field>

    <input
      type="text"
      tabIndex={-1}
      autoComplete="off"
      aria-hidden="true"
      value={form.honeypot}
      onChange={set("honeypot")}
      className="pointer-events-none absolute h-0 w-0 opacity-0"
    />
  </Group>
);

export default BriefScope;
